import { useEffect, useRef } from 'react';

import { useSidebarState } from '@components/sidebar';

import { JourneyNodeBase } from 'ui/journey-builder/node-types/types';
import { showActionSidebar } from 'ui/journey-builder/show-action-sidebar';

/**
 * Preserves the active action sidebar across tab switches.
 * Saves the active sidebar id on unmount and reopens it when nodes are available.
 */
export const usePreserveActionSidebar = (
  savedIdRef: React.MutableRefObject<string | null> | undefined,
  getNode: (id: string) => JourneyNodeBase | undefined,
  hasNodes: boolean
) => {
  const { activeId } = useSidebarState();
  const activeIdRef = useRef(activeId);
  activeIdRef.current = activeId;

  useEffect(() => {
    return () => {
      if (savedIdRef) {
        savedIdRef.current = activeIdRef.current ?? null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const savedId = savedIdRef?.current;
    if (!savedId || !hasNodes) return;

    const node = getNode(savedId);
    if (!node) return;

    showActionSidebar(node);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNodes]);
};
